export function formatParams(params: { [key: string]: any }): string {
    const encodedParams = Object.entries(params)
        .flatMap(([key, value]) => {
            if (value === null || value === undefined) return [];

            if (Array.isArray(value)) {
                return value.map((item: any) => `${encodeURIComponent(key)}[]=${encodeURIComponent(item)}`);
            }

            return [`${encodeURIComponent(key)}=${encodeURIComponent(value)}`];
        })
        .join('&');

    return encodedParams ? `?${encodedParams}` : '';
}
